import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import { getRouteByPathname, getRouteName } from '@/utils/Route'

import { routes } from '../Router'

// log screen_view to ga4

const useScreenView = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const logScreenView = (loc) => {
      const route = getRouteByPathname(routes, loc.pathname)
      const routeName = getRouteName(route)
      dispatch({
        type: 'gtm/sendEvent',
        payload: {
          event: 'screen_view',
          screen_name: routeName,
        },
      })
    }

    logScreenView(location)

    const unlisten = history.listen((loc) => {
      logScreenView(loc)
    })

    return () => unlisten()
  }, [])

  return null
}

export default useScreenView
